import React from 'react'
import { Loading } from '@myxplor/ui'
import { FormCheckbox } from '@myxplor/forms'
import LocalAsyncStore from '../../../../../local-async-store'

const getChildName = enrolment =>
  `${enrolment.gov_record['childFirstName']} ${enrolment.gov_record['childLastName']} (${enrolment.gov_id})`

const formatChild = (enrolmentID, enrolment) => {
  if (Object.keys(enrolment).length === 0)
    return {
      id: enrolmentID,
      name: `Unkown child (${enrolmentID})`
    }

  return enrolmentID === enrolment.gov_id
    ? {
      id: enrolmentID,
      name: getChildName(enrolment)
    }
    : {
      id: enrolmentID,
      name: `Unkown child (${enrolmentID})`
    }
}

const SelectChild = ({ select_child, onChange, values, enrolmentID, mapKey }) => {
  if (select_child.loading) return <Loading>Loading Child</Loading>
  const child = formatChild(enrolmentID, select_child.data)
  const childrenValues = values.children

  return (
    <FormCheckbox
      name={`children[${mapKey}]`}
      label={child.name}
      value={childrenValues[mapKey]}
      onChange={(keys, value) => onChange(keys, value ? child.id : null)}
      compact
    />
  )
}

export default LocalAsyncStore(
  'select_child',
  SelectChild,
  (props) => `/api/ccs-enrolments/${props.enrolmentID}`
)



// WEBPACK FOOTER //
// ./src/iss-case-claims/details/case-claim/form/select-children/select-child.jsx